<!-- <app-header></app-header> -->
<div class="pg-wrp">
  <div class="container">



    <div class="row">

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mid-screen-pnt">
        <h3 class="pay-sec">Click to Choose an Organization to transact further</h3>
        <div class="lod-sec ds-bk">
          <a class="cursor-pointer">
            <div class="ds-bk-sec" *ngFor="let list of user_list" (click)="setsession(list)">
              <div class="ds-txt ds-co">
                <label>Organization code</label>
                <p>{{list.custcode}}</p>
              </div>


              <div class="ds-txt2 ds-co">
                <label>Organization Name</label>
                <p>{{list.custName || '--'}}</p>
              </div>
              <div class="ds-txt2 ds-co">
                <label>Organization Address</label>
                <p>{{list.address || '--'}}</p>
              </div>


              <!-- <div class="lod-sec ds-bk">
                <div class="ds-bk-sec">
                      <div class="ds-txt ds-co">
                          <label>Invoice Number</label>
                          <p>QUO0124686</p>
                      </div>

                      <div class="ds-txt2 ds-co">
                          <label>Order Value</label>
                          <p>₹ 2000</p>
                      </div>
                      <div class="ds-txt3 ds-co">
                        <label>Valid till</label>
                        <p>09 Jan 2021</p>
                      </div>
                </div>
                    <div class="ad-fix-sec">
                        <div class="ds-tol">
                          <label>Status</label>
                          <button class="edit-btn"><a>Editable</a></button>
                        </div>
                      <div class="ad-cd-sc">
                        <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                      </div>
                  </div>
              </div>

              <div class="lod-sec ds-bk">
                <div class="ds-bk-sec">
                      <div class="ds-txt ds-co">
                          <label>Invoice Number</label>
                          <p>QUO0124686</p>
                      </div>

                      <div class="ds-txt2 ds-co">
                          <label>Order Value</label>
                          <p>₹ 2000</p>
                      </div>
                      <div class="ds-txt3 ds-co">
                        <label>Valid till</label>
                        <p>09 Jan 2021</p>
                      </div>
                </div>
                    <div class="ad-fix-sec">
                        <div class="ds-tol">
                          <label>Status</label>
                          <button class="edit-btn"><a>Editable</a></button>
                        </div>
                      <div class="ad-cd-sc">
                        <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                      </div>
                  </div>
              </div>

              <div class="lod-sec ds-bk">
                <div class="ds-bk-sec">
                      <div class="ds-txt ds-co">
                          <label>Invoice Number</label>
                          <p>QUO0124686</p>
                      </div>

                      <div class="ds-txt2 ds-co">
                          <label>Order Value</label>
                          <p>₹ 2000</p>
                      </div>
                      <div class="ds-txt3 ds-co">
                        <label>Valid till</label>
                        <p>09 Jan 2021</p>
                      </div>
                </div>
                    <div class="ad-fix-sec">
                        <div class="ds-tol">
                          <label>Status</label>
                          <button class="edit-btn"><a>Editable</a></button>
                        </div>
                      <div class="ad-cd-sc">
                        <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                      </div>
                  </div>
              </div>

              <div class="lod-sec ds-bk">
                <div class="ds-bk-sec">
                      <div class="ds-txt ds-co">
                          <label>Invoice Number</label>
                          <p>QUO0124686</p>
                      </div>

                      <div class="ds-txt2 ds-co">
                          <label>Order Value</label>
                          <p>₹ 2000</p>
                      </div>
                      <div class="ds-txt3 ds-co">
                        <label>Valid till</label>
                        <p>09 Jan 2021</p>
                      </div>
                </div>
                    <div class="ad-fix-sec">
                        <div class="ds-tol">
                          <label>Status</label>
                          <button class="edit-btn"><a>Editable</a></button>
                        </div>
                      <div class="ad-cd-sc">
                        <p>Add to Cart<img src="../../../assets/images/ad-arrow.png" alt=""></p>
                      </div>
                  </div>
              </div> -->

            </div>
          </a>
        </div>

        <div class="btn-sec mid-btn">
          <button (click)="reqAssistance()"><a>Need Assistance</a></button>
        </div>
      </div>
    </div>
    <app-footer></app-footer>